/**
 * TanStack Query hooks for `24-7-tier-blind-support-with-published-sla`.
 *
 * Thin wrappers over ./api functions. All data-layer side-effects live in
 * api.ts (D6); this file only binds them to query keys + invalidation.
 */

import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	createTicket,
	fetchPublishedSla,
	listTickets,
	supportTicketQueryKeys,
	type CreateTicketBody,
	type CreateTicketResponse,
	type ListTicketsResponse,
	type PublishedSlaResponse,
} from "./api";

export function useSupportTicketList(): UseQueryResult<ListTicketsResponse, Error> {
	return useQuery({
		queryKey: supportTicketQueryKeys.list(),
		queryFn: listTickets,
	});
}

export function usePublishedSla(): UseQueryResult<PublishedSlaResponse, Error> {
	return useQuery({
		queryKey: supportTicketQueryKeys.sla(),
		queryFn: fetchPublishedSla,
		staleTime: 5 * 60 * 1000,
	});
}

export function useSupportTicketCreate(): UseMutationResult<
	CreateTicketResponse,
	Error,
	CreateTicketBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createTicket,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: supportTicketQueryKeys.all });
		},
	});
}
